import { iccService } from './../services/icc/icc.service';
import { PubSubService } from '../service/pubSub.service';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var inboundcallcenterComponent = (function () {
    function inboundcallcenterComponent(iccService, pubsub) {
        this.iccService = iccService;
        this.pubsub = pubsub;
        this.iccData = {};
        this.depId = 1003; // default main id
        this.depName = 'MAIN';
        this.servicesListArr = [];
    }
    inboundcallcenterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getDataSub = this.pubsub.$sub('getData', function (eventObject) {
            _this.getDepartmentDataByDepId();
        });
        this.getDepartmentDataByDepId();
    };
    inboundcallcenterComponent.prototype.depOptionClicked = function (depId) {
        this.depId = depId;
        this.getDepartmentDataByDepId();
    };
    inboundcallcenterComponent.prototype.getDepartmentDataByDepId = function () {
        var _this = this;
        this.iccService.getInboundCallCenterData(this.depId).then(function (result) {
            if (result && result[0]) {
                _this.iccData = result[0];
                _this.servicesListArr = _this.convertObjectToArray(_this.iccData['servicesList']);
                _this.depName = _this.iccData['department']['name'];
            }
            else {
                _this.iccData = {};
                _this.servicesListArr = [];
            }
        }, function (error) {
            console.log(error);
        });
    };
    inboundcallcenterComponent.prototype.convertObjectToArray = function (obj) {
        var tempArr = [];
        for (var i = 0; i < Object.keys(obj).length; i++) {
            var value = {};
            value[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            tempArr.push(obj[Object.keys(obj)[i]]);
        }
        return tempArr;
    };
    inboundcallcenterComponent.prototype.serviceListTrackBy = function (item) {
        return item[Object.keys(item)[0]];
    };
    inboundcallcenterComponent.prototype.ngOnDestroy = function () {
        this.getDataSub.unsubscribe();
    };
    return inboundcallcenterComponent;
}());
export { inboundcallcenterComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/inboundcallcenterComponent/inboundcallcenter.component.ts.pre-build-optimizer.js